import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Link } from 'react-router';


export default createReactClass({

   propTypes: {
      onLogout: PropTypes.func,
      onChange: PropTypes.func,
      username: PropTypes.string,
   },

   getDefaultProps() {
      return {
         onLogout() {},
         onChange() {},
         username: '',
      };
   },

   componentDidMount() {
      this.getUserData();
      this.handleFocus = _.debounce(this.handleFocus, 1000);
      window.addEventListener('focus', this.handleFocus);
   },

   componentWillUnmount() {
      this.handleFocus.cancel();
      window.removeEventListener('focus', this.handleFocus);
   },

   getUserData() {
      window.xnat.whoami().then((username) => {
         if (!this.props.username) {
            this.props.onChange(username);
         }
         else if (username == null) {
            // session abgelaufen, wird schon von App.js übernommen
         }
         else if (this.props.username !== username) {
            this.props.onChange(username);
            if (window.confirm('Benutzer hat sich geändert - Seite neu laden?')) {
               window.location.reload();
            }
         } // else: (username === username) -> ignore
      });
   },

   handleFocus() {
      if (process.env.NODE_ENV !== 'production') return; // no auth checking in dev mode
      if (this.props.username) this.getUserData();
   },

   handleLogout() {
      window.xnat.logout()
         .then(this.props.onLogout);
      if (process.env.NODE_ENV !== 'production') {
         window.config.login.autologin = false;
      }
   },

   toggleFullscreen() {
      const wrapper = window.document.querySelector('.wrapper');
      wrapper.style.maxWidth = wrapper.style.maxWidth ? '' : '100%';
   },

   render() {
      return (
         <nav className="links">
            <span>{this.props.username.replace('_rm', ' (Regionalleiter)')}</span>
            <Link to="/">Rolle wechseln</Link>
            <button className="btn btn-link" style={{ padding: '1px 0' }} onClick={this.toggleFullscreen}>Vollbild</button>
            <a href="#/" onClick={this.handleLogout}>Logout</a>
         </nav>
      );
   },

});
